import { useState, useCallback, useRef, useEffect } from "react";
import { useContainer } from "unstated-next";
import axios, { CancelTokenSource, Method } from "axios";

import Message, { MessageType } from "../store/message";

export const useFetch = () => {
  const { addMessage } = useContainer(Message);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const activeHttpRequests = useRef<CancelTokenSource[]>([]);

  const sendRequest = useCallback(
    async (url: string, method: Method = "get", data: BodyInit | null = null, headers: HeadersInit = {}) => {
      setIsLoading(true);
      const cancelToken = axios.CancelToken;
      const tokenSource = cancelToken.source();
      activeHttpRequests.current.push(tokenSource);

      try {
        const response = await axios({
          method,
          url,
          data,
          headers,
          cancelToken: tokenSource.token,
        });

        const responseData = await response.data;
        activeHttpRequests.current = activeHttpRequests.current.filter((source) => source !== tokenSource);

        return responseData;
      } catch (error) {
        if (error.response) {
          const errorMessage = error.response.data.status_message;
          addMessage({ id: `${errorMessage}${Math.random()}`, message: errorMessage, type: MessageType.failed });
        } else {
          addMessage({ id: `${error.message}${Math.random()}`, message: error.message, type: MessageType.failed });
        }
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    return () => {
      activeHttpRequests.current.forEach((source) => source.cancel());
    };
  }, []);

  return { isLoading, sendRequest };
};
